import { useState, useEffect } from 'react';
import { GetCampaings } from '../api';
import CampaignSetupModal from './CampaignCreateModal';

export default function CampaignManager() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [showCreateModal, setShowCreateModal] = useState(false);

  useEffect(() => {
    loadCampaigns(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const loadCampaigns = async (pageNo) => {
    try {
      setLoading(true);
      const res = await GetCampaings(pageNo, limit);
      setCampaigns(res.data || []);
      setTotalPages(res.pagination?.totalPages || 1);
    } catch (error) {
      console.error('Failed to load campaigns', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return '#4caf50';
      case 'draft': return '#ff9800';
      case 'planned': return '#2196f3';
      case 'completed': return '#757575';
      default: return '#9e9e9e';
    }
  };

  const getTypeIcon = (type) => {
    switch (type) {
      case 'email': return '📧';
      case 'sms': return '📱';
      case 'social': return '🌐';
      case 'push': return '📢';
      default: return '📋';
    }
  };

  const formatDate = (date) => {
    if (!date) return '--';
    return new Date(date).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const handleCreateCampaign = () => {
    // You can set community info here if needed
    // For example: setSelectedCommunity(currentCommunity);
    setShowCreateModal(true);
  };

  const handleCampaignCreated = () => {
    setShowCreateModal(false);
    // Refresh the campaigns list
    loadCampaigns(1);
  };

  return (
    <>
      <div className="row-split">
        <div className="full-width card" style={{ width: '100%' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '20px 24px',
            borderBottom: '1px solid #e5e7eb'
          }}>
            <h2 style={{
              margin: 0,
              fontSize: '24px',
              fontWeight: '600',
              color: '#111827'
            }}>
              Campaigns
            </h2>
            
            <button
              onClick={handleCreateCampaign}
              style={{
                backgroundColor: '#3b82f6',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#2563eb';
                e.target.style.transform = 'translateY(-1px)';
                e.target.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.3)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = '#3b82f6';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}
            >
              <svg 
                width="16" 
                height="16" 
                viewBox="0 0 16 16" 
                fill="currentColor"
                style={{ marginRight: '4px' }}
              >
                <path d="M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 1 1 0-2h6V1a1 1 0 0 1 1-1z"/>
              </svg>
              Create Campaign
            </button>
          </div>

          {loading ? (
            <div style={{
              padding: '60px 40px',
              textAlign: 'center',
              color: '#6b7280',
              fontSize: '16px'
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                border: '3px solid #f3f4f6',
                borderTop: '3px solid #3b82f6',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 16px'
              }}></div>
              Loading campaigns...
            </div>
          ) : campaigns.length === 0 ? (
            <div style={{
              padding: '80px 40px',
              textAlign: 'center',
              color: '#6b7280'
            }}>
              <div style={{
                fontSize: '48px',
                marginBottom: '16px',
                opacity: '0.3'
              }}>
                📋
              </div>
              <h3 style={{
                fontSize: '18px',
                fontWeight: '500',
                margin: '0 0 8px 0',
                color: '#374151'
              }}>
                No campaigns yet
              </h3>
              <p style={{
                fontSize: '14px',
                margin: '0 0 24px 0',
                color: '#6b7280'
              }}>
                Start by creating your first campaign
              </p>
              <button
                onClick={handleCreateCampaign}
                style={{
                  backgroundColor: '#3b82f6',
                  color: 'white',
                  border: 'none',
                  padding: '10px 24px',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                  <path d="M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 1 1 0-2h6V1a1 1 0 0 1 1-1z"/>
                </svg>
                Create First Campaign
              </button>
            </div>
          ) : (
            <>
              <div style={{ overflowX: 'auto' }}>
                <table style={{
                  width: '100%',
                  borderCollapse: 'collapse'
                }}>
                  <thead>
                    <tr style={{
                      backgroundColor: '#f9fafb',
                      borderBottom: '1px solid #e5e7eb'
                    }}>
                      {['Title', 'Type', 'Status', 'Target', 'Period', 'Progress', 'Performance'].map((header, index) => (
                        <th key={index} style={{
                          padding: '16px 20px',
                          textAlign: 'left',
                          fontSize: '12px',
                          fontWeight: '600',
                          color: '#6b7280',
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em',
                          whiteSpace: 'nowrap'
                        }}>
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {campaigns.map(c => (
                      <tr 
                        key={c._id} 
                        style={{
                          borderBottom: '1px solid #e5e7eb',
                          transition: 'background-color 0.2s ease',
                          cursor: 'pointer'
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.backgroundColor = '#f9fafb';
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                      >
                        <td style={{ padding: '20px' }}>
                          <div style={{
                            fontWeight: '500',
                            fontSize: '14px',
                            color: '#111827',
                            marginBottom: '4px'
                          }}>
                            {c.title}
                          </div>
                          <div style={{
                            fontSize: '12px',
                            color: '#6b7280'
                          }}>
                            {c.community?.name || 'No community'}
                          </div>
                        </td>

                        <td style={{ padding: '20px' }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}>
                            <span style={{ fontSize: '16px' }}>
                              {getTypeIcon(c.type)}
                            </span>
                            <span style={{
                              fontSize: '14px',
                              color: '#374151'
                            }}>
                              {c.type}
                            </span>
                          </div>
                        </td>

                        <td style={{ padding: '20px' }}>
                          <span style={{
                            backgroundColor: getStatusColor(c.status),
                            color: '#fff',
                            padding: '4px 12px',
                            borderRadius: '20px',
                            fontSize: '12px',
                            fontWeight: '500',
                            display: 'inline-block',
                            textTransform: 'capitalize'
                          }}>
                            {c.status}
                          </span>
                        </td>

                        <td style={{ padding: '20px' }}>
                          <div style={{
                            fontSize: '14px',
                            fontWeight: '500',
                            color: '#111827'
                          }}>
                            ₹{c.totalAmountNeeded?.toLocaleString() || '0'}
                          </div>
                        </td>

                        <td style={{ padding: '20px' }}>
                          <div style={{
                            fontSize: '14px',
                            color: '#111827',
                            marginBottom: '4px'
                          }}>
                            {formatDate(c.createdAt)}
                          </div>
                          <div style={{
                            fontSize: '12px',
                            color: '#6b7280'
                          }}>
                            to {formatDate(c.endDate || c.dueDate)}
                          </div>
                        </td>

                        <td style={{ padding: '20px' }}>
                          <div style={{ marginBottom: '8px' }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px'
                            }}>
                              <div style={{
                                flex: 1,
                                height: '6px',
                                backgroundColor: '#e5e7eb',
                                borderRadius: '3px',
                                overflow: 'hidden'
                              }}>
                                <div style={{
                                  width: `${c.progress || 0}%`,
                                  height: '100%',
                                  backgroundColor: '#10b981',
                                  borderRadius: '3px',
                                  transition: 'width 0.3s ease'
                                }}></div>
                              </div>
                              <span style={{
                                fontSize: '14px',
                                fontWeight: '500',
                                color: '#111827',
                                minWidth: '40px'
                              }}>
                                {c.progress || 0}%
                              </span>
                            </div>
                          </div>
                          {c.isCompleted && (
                            <span style={{
                              fontSize: '12px',
                              color: '#10b981',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '4px'
                            }}>
                              ✅ Completed
                            </span>
                          )}
                        </td>

                        <td style={{ padding: '20px' }}>
                          <div style={{
                            fontSize: '12px',
                            color: '#374151',
                            lineHeight: '1.6'
                          }}>
                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              marginBottom: '4px'
                            }}>
                              <span>Opened:</span>
                              <span style={{ fontWeight: '500' }}>{c.opened || 0}</span>
                            </div>
                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              marginBottom: '4px'
                            }}>
                              <span>Clicked:</span>
                              <span style={{ fontWeight: '500' }}>{c.clicked || 0}</span>
                            </div>
                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between'
                            }}>
                              <span>Paid Users:</span>
                              <span style={{ fontWeight: '500' }}>{c.paidUsers || 0}</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '20px 24px',
                borderTop: '1px solid #e5e7eb'
              }}>
                <div style={{
                  fontSize: '14px',
                  color: '#6b7280'
                }}>
                  Showing {campaigns.length} of {page * limit} campaigns
                </div>
                
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px'
                }}>
                  <button
                    onClick={() => setPage(p => p - 1)}
                    disabled={page === 1}
                    style={{
                      padding: '8px 16px',
                      border: '1px solid #d1d5db',
                      backgroundColor: page === 1 ? '#f3f4f6' : 'white',
                      color: page === 1 ? '#9ca3af' : '#374151',
                      borderRadius: '6px',
                      fontSize: '14px',
                      fontWeight: '500',
                      cursor: page === 1 ? 'not-allowed' : 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseOver={(e) => {
                      if (page !== 1) {
                        e.target.style.backgroundColor = '#f9fafb';
                        e.target.style.borderColor = '#9ca3af';
                      }
                    }}
                    onMouseOut={(e) => {
                      if (page !== 1) {
                        e.target.style.backgroundColor = 'white';
                        e.target.style.borderColor = '#d1d5db';
                      }
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                    Previous
                  </button>
                  
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                  }}>
                    {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                      const pageNumber = i + 1;
                      return (
                        <button
                          key={pageNumber}
                          onClick={() => setPage(pageNumber)}
                          style={{
                            width: '32px',
                            height: '32px',
                            border: page === pageNumber ? '2px solid #3b82f6' : '1px solid #d1d5db',
                            backgroundColor: page === pageNumber ? '#3b82f6' : 'white',
                            color: page === pageNumber ? 'white' : '#374151',
                            borderRadius: '6px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                          }}
                        >
                          {pageNumber}
                        </button>
                      );
                    })}
                    {totalPages > 5 && (
                      <span style={{ color: '#6b7280', padding: '0 8px' }}>...</span>
                    )}
                  </div>
                  
                  <button
                    onClick={() => setPage(p => p + 1)}
                    disabled={page === totalPages}
                    style={{
                      padding: '8px 16px',
                      border: '1px solid #d1d5db',
                      backgroundColor: page === totalPages ? '#f3f4f6' : 'white',
                      color: page === totalPages ? '#9ca3af' : '#374151',
                      borderRadius: '6px',
                      fontSize: '14px',
                      fontWeight: '500',
                      cursor: page === totalPages ? 'not-allowed' : 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseOver={(e) => {
                      if (page !== totalPages) {
                        e.target.style.backgroundColor = '#f9fafb';
                        e.target.style.borderColor = '#9ca3af';
                      }
                    }}
                    onMouseOut={(e) => {
                      if (page !== totalPages) {
                        e.target.style.backgroundColor = 'white';
                        e.target.style.borderColor = '#d1d5db';
                      }
                    }}
                  >
                    Next
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Create Campaign Modal */}
      {showCreateModal && (
        <CampaignSetupModal
          isOpen={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          onCampaignCreated={handleCampaignCreated}
        />
      )}

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        .row-split {
          width: 100%;
          padding: 20px;
          background: #f9fafb;
          min-height: 100vh;
        }
        
        .full-width {
          width: 100%;
        }
        
        .card {
          background: white;
          border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }
      `}</style>
    </>
  );
}